const getters = {
  user: state => state.user.user,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userName: state => state.user.userName,
  roles: state => state.user.roles,
  roleList: state => state.user.roleList,
  permissions: state => state.user.permissions,
  deptList: state => state.dept.deptList,
  phonenumber: state => state.user.phonenumber,
  projectList: state => state.project.projectList,
  userId: state => state.user.userId,
  mainAccountInfo: state => state.user.mainAccountInfo,
  hasChildAccount: state => state.user.hasChildAccount,
  schoolType: state => state.user.schoolType,
  isSuper: state => state.user.isSuper,
  roleName: state => state.user.roleName,
  roleId: state => state.user.roleId,
  deptId: state => state.user.deptId,
  deptRoleName: state => state.user.deptRoleName,
  vipPackage: state => state.user.vipPackage
}
export default getters